module.exports = __webpack_public_path__ + "static/media/buy_finish_service_rent_4.2a24f6e5.jpg";